'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubButton = function GithubButton(props) {
  var user = props.user,
      repo = props.repo,
      type = props.type,
      width = props.width,
      height = props.height,
      count = props.count,
      large = props.large;

  var src = 'https://ghbtns.com/github-btn.html?user=' + user + '&repo=' + repo + '&type=' + type;
  if (count) src += '&count=true';
  if (large) src += '&size=large';

  return _react2.default.createElement('iframe', {
    src: src,
    frameBorder: '0',
    allowTransparency: 'true',
    scrolling: '0',
    width: width,
    height: height,
    style: { border: 'none', width: width, height: height } });
};

GithubButton.propTypes = {
  user: _react2.default.PropTypes.string.isRequired,
  repo: _react2.default.PropTypes.string.isRequired,
  type: _react2.default.PropTypes.oneOf(['star', 'watch', 'fork', 'follow']).isRequired,
  width: _react2.default.PropTypes.number.isRequired,
  height: _react2.default.PropTypes.number.isRequired,
  count: _react2.default.PropTypes.bool,
  large: _react2.default.PropTypes.bool
};

exports.default = GithubButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GithubButton/GithubButton.js
// module id = 1177
// module chunks = 0